var useScreenWidth=function(a){return window.matchMedia("(max-width: ".concat(a,"px)")).matches};export default useScreenWidth;